module.exports = __webpack_public_path__ + "img/daifahuo.113b3452.png";